import axios from 'axios';

export const requestsApprovedApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/requests-approved`,
    headers: {
        'Content-Type': 'application/json'
    }
})